import { cn } from "@/lib/utils";

const STYLES = {
  live: { label: "Live", dot: "bg-success pulse-dot", text: "text-success border-success/40 bg-success/10" },
  soon: { label: "Coming soon", dot: "bg-muted-foreground", text: "text-muted-foreground bg-muted" },
  scheduled: { label: "Scheduled run", dot: "bg-warning", text: "text-warning" },
  active: { label: "Active", dot: "bg-success", text: "text-success" },
  pending: { label: "Pending", dot: "bg-warning", text: "text-warning" },
  deactivated: { label: "Deactivated", dot: "bg-muted-foreground", text: "text-muted-foreground" },
};

export const StatusPill = ({ status, label, testid }) => {
  const s = STYLES[status] || STYLES.soon;
  return (
    <span data-testid={testid} className={cn("inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border bg-card px-2.5 py-0.5 text-xs font-medium", s.text)}>
      <span className={cn("h-2 w-2 rounded-full", s.dot)} aria-hidden="true" />
      {label || s.label}
    </span>
  );
};
